export default __webpack_public_path__ + "static/media/sitting-on-chair.bf3bd7b8.png";